
function clearAll(){
    project.activeLayer.children.map(function(c){
      if(c.children){
        c.children.map(function(ch){
          ch.remove();
        })
      }
      c.remove();
    })
    project.activeLayer.clear();
  }
  var a = [1,2,3,4,5,6];
  Array.prototype.pluckRandom = function(){
    console.log(this)
    var choice = num(this.length);
    return this.splice(choice,1)
  }
  
  function generateStairs(){
    clearAll()
    var SHADOW_HEIGHT = .85;
    var COLOR_CHOICES = ["red","green","blue","yellow"];
    var shadowFineness = 300;
    var box = new Path.Rectangle(view.bounds);//0,0,600+num(400),450+num(400));
    box.strokeColor = "black"
    box.fillColor = COLOR_CHOICES.pluckRandom();
    var amt = 5+num(30);
    var ratio = .2+Math.random()*.3;
    var steep = box.bounds.height / (amt*1.5)
    var lines = new Group();
    var size = box.bounds.width/amt;
    var diagonal = new Path();
  
    diagonal.strokeColor = "black";
    var dHeight = 0;
    var stepColor = COLOR_CHOICES.pluckRandom();
    for (var i = 0; i < amt; i++) {
      var vertical = new Group();
      var left = new Path();
      var right = new Path();
      right.strokeColor = left.strokeColor = "black";
      left.add(new Point(box.bounds.x+i*(size),dHeight));
      left.add(new Point(box.bounds.x+i*(size),box.bounds.y+box.bounds.height));
      diagonal.add(left.segments[0].point.x,dHeight);
      dHeight+= steep;
      left.add(new Point(box.bounds.x+(size*ratio)+i*(size),box.bounds.y+box.bounds.height));
      left.add(new Point(box.bounds.x+(size*ratio)+i*(size),dHeight));
      left.fillColor = stepColor;
      diagonal.add(left.segments[2].point.x,dHeight)
      lines.children.push(left);
      //lines.children.push(right);
    }
    diagonal.add(box.bounds.topRight.x,dHeight)
    diagonal.add(box.bounds.topRight)
    diagonal.closed = true;
    diagonal.fillColor = COLOR_CHOICES.pluckRandom();
  
  
    var shadow = new Path();
    shadow.add(box.bounds.topLeft);
    shadow.add(box.bounds.topRight);
    shadow.add(box.bounds.topRight+[0,box.bounds.height*SHADOW_HEIGHT]);
  
  
    shadow.closed = true;
    var offset = box.bounds.topRight+[0,box.bounds.height*SHADOW_HEIGHT];
    offset = shadow.getOffsetOf(offset);
    var remainingLine = shadow.length - offset;
    var liners = new Group();
    for(var i=0;i<shadowFineness;i++){
      var line = new Path();
      line.strokeColor = "black";
      var next = shadow.getPointAt(offset);
      line.add(next);
      line.add(next.x,0);
      offset+= (remainingLine/shadowFineness)
      liners.children.push(line)
    }
  
    var all = new Group({children:[box,shadow,liners,lines,diagonal]});
    all.bounds.center = view.bounds.center;
    all.rotate(20);
    all.fitBounds(view.bounds)
  }
  
  function onMouseDown(){
    generateStairs();
    console.log("ok")
  }
  generateStairs();